import React from 'react'
import { Link } from 'react-router-dom'
import nodata from "../../assets/images/no-data.png";
function Dashboard({ selectedMenu, ListedMenu }) {
    //console.log(ListedMenu)
    // ""
    const newData = Object.keys(ListedMenu).reduce((acc, key) => {
        if (key !== 'Dashboard') {
            acc[key] = ListedMenu[key];
        }
        return acc;
    }, {});
    // //console.log(    "tttttttttttt>",Object.values(newData))
    const renderDashboardTile = () => {
        return (
            <>

                {Object.entries(newData).map(([key, value], index) => {
                    if (Array.isArray(value) && value.length > 0) {
                        return (
                            <>
                                {value.map((itm, subIndex) => (
                                    // //console.log(itm),
                                    <Link to={itm.path} className=' uderline col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                                        <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                            <span className='fw_600  m-auto'>{itm.sideMenuName}</span>
                                        </div>
                                    </Link>
                                ))}


                            </>




                        )

                    }
                })}
            </>
        )
    }
    return (
        <>
            <div className="px-3 flex-fill">
                <div className="bg-white br_15 custom_scroll1 main__area overflow-auto px-4 py-3 w-100">
                    <div className='mb-2'>
                        <h4 className='font_18 fw_600 text_master2 mb-3 py-1'>Dashboard</h4>
                        <div className='row'>
                            {
                                !Object.values(newData).map((itm) => itm.length === 0).every((itm) => itm)
                                    ? renderDashboardTile() : <>

                                        <div className="d-flex flex-column align-items-center mt-0 mt-md-5">
                                            <img
                                                src={nodata}
                                                className="no_data_thumbnail object_fit_contain"
                                            />
                                            <h4 className="text_gray7 font_16 mt-3">
                                                {" "}
                                                You Don't have any Product to visit
                                            </h4>
                                        </div>
                                    </>

                            }
                            { }

                            {/* <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                            <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                <span className='fw_600 m-auto'>PAN Card Reader</span>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                            <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                <span className='fw_600 m-auto'>PAN Card Reader</span>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                            <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                <span className='fw_600 m-auto'>PAN Card Reader</span>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                            <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                <span className='fw_600 m-auto'>PAN Card Reader</span>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                            <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                <span className='fw_600 m-auto'>PAN Card Reader</span>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                            <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                <span className='fw_600 m-auto'>PAN Card Reader</span>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                            <div className='bg-white br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 shadow_sm1 text-center text_master2 min_h_65x'>
                                <span className='fw_600 m-auto'>PAN Card Reader</span>
                            </div>
                        </div> */}
                            <div className=' d-none col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3'>
                                <div className='bg_light2 br_10 cursor-pointer d-flex d-grid h-100 px-3 px_hover_1 py-2 text-center text_master2 min_h_65x'>
                                    <span className='fw_600 m-auto'>View More</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dashboard
